// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"GR-z","categoryName":"HR-z","categoryNameSearchHeader":"IR-z","categoryContent":"JR-z","bottomAligned":"KR-z","image":"LR-z","imageNoBackground":"MR-z"};